import './App.css'
import { EanProvider } from './context/eanContext'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Mirror from './Mirror'

function App() {
  return (
    <EanProvider>
      <div className="App">
        <div className="ean-holder" data-ean="713132436714"></div>
        <div className="ean-holder" data-ean="8056597345460"></div>
        <button id="startVmButton" style={{ display: 'none' }}>
          START VM
        </button>
        <iframe
          title="virtualMachine"
          width="100%"
          height="1080px"
          src="./vm"
          allow="camera"
          style={{ opacity: 0, display: 'none' }}
        ></iframe>
        <Router>
          <Routes>
            <Route path="/vm" element={<Mirror />} />
          </Routes>
        </Router>
        <Mirror />
      </div>
    </EanProvider>
  )
}

export default App
